import {
  BACKEND_ENDPOINT,
  CREATE_DEVICE,
  UPDATE_DEVICE,
  DELETE_DEVICE,
  GET_DEVICES,
  GET_DEVICE_DETAIL,
  GET_DEVICE_FILE,
} from "./urls_dev";
import axios from "axios";
import { getUserById } from "../newBackendApi/newUser";
import { getIdToken, getSessionClaims } from "../../lib/session";

const getAuthHeaders = () => {
  const token = getIdToken();
  if (!token) throw new Error("User not authenticated.");
  return {
    Authorization: token,
    "Content-Type": "application/json",
  };
};

export const deviceDefinition = {
  deviceId: "",
  deviceType: "",
  deviceName: "",
  deviceDescription: "",
  createdOn: Math.floor(Date.now() / 1000),
  updatedOn: Math.floor(Date.now() / 1000),
  deviceStatus: "ACTIVE",
  isDeleted: false,
  EntityType: "DEVICE",
  Timestamp: Math.floor(Date.now() / 1000),
  ChangeLog: "created by the user",
};

export const createDevice = async (deviceData) => {
  const headers = await getAuthHeaders();
  const claims = getSessionClaims();

  const newDeviceData = { ...deviceData };
  for (const key in deviceDefinition) {
    if (newDeviceData[key] === undefined) {
      newDeviceData[key] = deviceDefinition[key];
    }
  }

  const body = {
    operation: "CREATE",
    entityType: "DEVICE",
    data: {
      ...newDeviceData,
      createdBy: claims?.email,
      "association:USER": [
        {
          id: "cognitoId",
          value: claims?.sub,
          entityType: "USER",
        },
      ],
    },
  };

  try {
    const backendUrl = `${BACKEND_ENDPOINT}${CREATE_DEVICE}`;
    const response = await axios.post(backendUrl, body, { headers });
    return response.data;
  } catch (error) {
    console.error("Error creating new device:", error.response?.data || error);
    throw new Error("Failed to create new device");
  }
};

export const getDevices = async (listParams) => {
  const headers = await getAuthHeaders();
  const claims = getSessionClaims();

  const backendUrl = `${BACKEND_ENDPOINT}${GET_DEVICES}`;
  const body = {
    operation: "LIST",
    entityType: "DEVICE",
    data: {
      parentId: claims?.sub,
      parentType: "USER",
      limit: listParams?.limit || 100,
      page: listParams?.page || 1,
      lastEvaluatedKey: listParams?.lastEvaluatedKey || null,
      // filter: "Jetcore",
      requiredFields: ["deviceId", "deviceName", "deviceType", "deviceStatus"],
    },
  };

  try {
    const response = await axios.post(backendUrl, body, { headers });
    const deviceData =
      typeof response.data.body === "string"
        ? JSON.parse(response.data.body)
        : response.data;
    return deviceData;
  } catch (error) {
    console.error("Error fetching devices:", error.response?.data || error);
    throw new Error("Unable to fetch devices.");
  }
};

export const getDeviceFile = async (listParams) => {
  const headers = await getAuthHeaders();
  const claims = getSessionClaims();
  const user = await getUserById(claims?.sub);

  const backendUrl = `${BACKEND_ENDPOINT}${GET_DEVICE_FILE}`;
  const body = {
    operation: "GETFILE",
    entityType: "DEVICE",
    data: {
      developerToken: user?.developerToken,
      parentId: claims?.sub,
      parentType: "USER",
      limit: listParams?.limit || 100,
      page: listParams?.page || 1,
      lastEvaluatedKey: listParams?.lastEvaluatedKey || null,
      // filter: "Jetcore",
    },
  };

  try {
    const response = await axios.post(backendUrl, body, { headers });
    const deviceData =
      typeof response.data.body === "string"
        ? JSON.parse(response.data.body)
        : response.data;
    return deviceData;
  } catch (error) {
    console.error("Error fetching devices:", error.response?.data || error);
    throw new Error("Unable to fetch devices.");
  }
};

export const getDeviceDetails = async (deviceObject) => {
  const headers = await getAuthHeaders();
  const backendUrl = `${BACKEND_ENDPOINT}${GET_DEVICE_DETAIL}`;
  const body = {
    operation: "READ",
    entityType: "DEVICE",
    data: deviceObject,
  };

  try {
    const response = await axios.post(backendUrl, body, { headers });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching device details:",
      error.response?.data || error
    );
    throw new Error("Failed to retrieve device details.");
  }
};

export const updateDevice = async (deviceObject) => {
  const headers = await getAuthHeaders();
  const backendUrl = `${BACKEND_ENDPOINT}${UPDATE_DEVICE}`;
  const body = {
    operation: "UPDATE",
    entityType: "DEVICE",
    data: deviceObject,
  };

  try {
    const response = await axios.post(backendUrl, body, { headers });
    return response.data;
  } catch (error) {
    console.error("Error updating device:", error.response?.data || error);
    throw new Error("Failed to update device.");
  }
};

export const deleteDevices = async (deviceObject) => {
  const headers = await getAuthHeaders();
  const backendUrl = `${BACKEND_ENDPOINT}${DELETE_DEVICE}`;
  const body = {
    operation: "DELETE",
    entityType: "DEVICE",
    data: deviceObject,
  };

  try {
    const response = await axios.post(backendUrl, body, { headers });
    return response.data;
  } catch (error) {
    console.error("Error deleting device:", error.response?.data || error);
    throw new Error("Failed to delete device.");
  }
};
